import styled from "@emotion/styled";

export const UserStats = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: clamp(4px, 1vw, 10px);
  text-align: center;

  p {
    font-size: clamp(12px, 1.5vw, 16px);
    font-weight: 600;
    margin: 0;
  }

  h4 {
    font-size: clamp(16px, 2.5vw, 28px);
    font-weight: 900;
    margin: 0;
  }
`;
